/**
 * Horaires de prière (API Aladhan, sans clé) — utilitaires réutilisables.
 * Utilisé par le tableau de bord (prochaine prière) ; peut servir ailleurs.
 */

import { getPosition } from './geo';

export const PRAYERS = [
  { key: 'Fajr', label: 'Fajr', wolof: 'Soubh' },
  { key: 'Dhuhr', label: 'Dhuhr', wolof: 'Tisbar' },
  { key: 'Asr', label: 'Asr', wolof: 'Takkusan' },
  { key: 'Maghrib', label: 'Maghrib', wolof: 'Timis' },
  { key: 'Isha', label: 'Isha', wolof: 'Guéwé' }
];

// Repli : Dakar
const DAKAR = { lat: 14.6928, lon: -17.4467 };

// Géolocalisation tolérante : repli silencieux sur Dakar en cas de refus/échec
// (le bandeau prière du dashboard doit toujours afficher quelque chose).
export const getCoords = () => getPosition().catch(() => DAKAR);

export const fetchTimings = async (lat, lon) => {
  const ts = Math.floor(Date.now() / 1000);
  const res = await fetch(
    `https://api.aladhan.com/v1/timings/${ts}?latitude=${lat}&longitude=${lon}&method=2`
  );
  if (!res.ok) throw new Error('Aladhan API error');
  const json = await res.json();
  return json.data.timings;
};

/**
 * Détermine la prochaine prière à partir des horaires du jour.
 * @returns {{ key, label, wolof, time:'HH:MM', date:Date, isTomorrow:boolean } | null}
 */
export const getNextPrayer = (timings, now = new Date()) => {
  if (!timings) return null;
  const toDate = (hhmm) => {
    const [h, m] = hhmm.split(':').map(Number);
    const d = new Date(now);
    d.setHours(h, m, 0, 0);
    return d;
  };
  for (const p of PRAYERS) {
    const raw = timings[p.key];
    if (!raw) continue;
    const time = raw.slice(0, 5);
    const d = toDate(time);
    if (d > now) return { ...p, time, date: d, isTomorrow: false };
  }
  // Toutes passées → Fajr de demain
  const fajr = (timings.Fajr || '06:00').slice(0, 5);
  const d = toDate(fajr);
  d.setDate(d.getDate() + 1);
  return { ...PRAYERS[0], time: fajr, date: d, isTomorrow: true };
};

/** Formate une durée en ms en "1h 23min" / "12min". */
export const formatCountdown = (ms) => {
  const totalMin = Math.max(0, Math.round(ms / 60000));
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}min`;
  return `${m}min`;
};
